module.exports = __webpack_public_path__ + "static/media/down-arrow.12d57972.svg";